export function createElement(
  tagName: string,
  attributes: Record<string, string | boolean | Record<string, string>> = {},
  content: string = ""
) {
  const element = document.createElement(tagName);

  for (const [attributeName, attributeValue] of Object.entries(attributes)) {
    if (
      typeof attributeValue !== "string" &&
      typeof attributeValue !== "boolean"
    ) {
      let style = "";
      for (const [property, value] of Object.entries(attributeValue)) {
        style += `${property}:${value}; `;
      }

      element.setAttribute(attributeName, style);
    } else {
      element.setAttribute(attributeName, attributeValue.toString());
    }
  }

  if (content !== "") {
    element.textContent = content;
  }

  return element;
}

export function createAppContainer(appName: string) {
  const appId = "application:" + appName;
  const appContainerExists = !!document.getElementById(appId);

  if (!appContainerExists) {
    const appContainer = createElement("div", { id: "application:" + appName });
    document.getElementById("root")?.appendChild(appContainer);
  }
}
